import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { GET_ONE, GET_LIST, Button } from "react-admin";
import dataProviderFactory from "../dataProvider";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
// import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Book from "@material-ui/icons/Book";
import { isNil, filter, propEq, prop, head } from "ramda";
import styled from "styled-components";
import Print from "@material-ui/icons/Print";
import ReactToPrint from "react-to-print";
import moment_tz from 'moment-timezone';
import LinearProgress from "@material-ui/core/LinearProgress";
import {  UPDATE } from 'react-admin'
import { getCountryByID, getNationality } from "../util";
import {
  buildRentalPromoSnapshot,
} from "../util/rentalPromo";
import { RentalPromoBadges } from "./RentalPromoBadges";
import {
  resolveBookingInsuranceId,
  insuranceLabel,
  isPaidInsurance,
} from "../util/rentalInsurance";
import { estimateRentalFromBooking } from "../util/estimateRentalFromBooking";

// const StyledDialogTitle = styled(DialogTitle)({
//   color: "#ff9800 !important"
// });

const StyledH4 = styled.h4({
  color: "#ff9800"
});

// const StyledAddress = styled.div({
//   textTransform: "uppercase"
// });

class RentalBookingFormButton extends Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
  }

  async fetchData(id) {
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(GET_ONE, "bookings", { id });
    const priceDate = prop('price_date', response.data);

    const modelPrices1 = await dataProvider(GET_LIST, "prices", {
      filter: {
        prices_vehicle_model_id: response.data.vehicle_model_1,
        for_date: priceDate,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });

    const modelPrices2 = await dataProvider(GET_LIST, "prices", {
      filter: {
        prices_vehicle_model_id: response.data.vehicle_model_2,
        for_date: priceDate,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });

    const locationFeePrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        for_price_item_id: "rental_location_fee",
        location_id_1: response.data.location_id_1,
        location_id_2: response.data.location_id_2,
        for_date: priceDate,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });

    const gpsPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "gps_device",
        for_date: priceDate,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });

    const insurancePrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "insurance",
        for_date: priceDate,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });

    const responseClient = await dataProvider(GET_ONE, "clients", {
      id: response.data.client_id
    });
    return Object.assign(
      {
        v1Prices: modelPrices1.data,
        v2Prices: modelPrices2.data,
        locationFees: locationFeePrices.data,
        gpsPrices: gpsPrices.data,
        insurancePrices: insurancePrices.data,
        referral: responseClient.data.referral
      },
      response.data
    );
  }

  state = {
    data: null,
    error: false,
    editBooking: false,
    r_last_name:null,
    r_first_name: null,
    showDialog: false,
    retirementDate: Date.now(),
    countries: [],
  };

  async componentDidUpdate() {
    if (this.state.showDialog && isNil(this.state.data)) {
      const id = this.props.bookingId;
      await this.updateState(id);
    }
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    await this.loadCountries();
  }

  loadCountries = async () => {
    try {
      const dataProvider = await dataProviderFactory("rest");
      const response = await dataProvider(GET_LIST, "countries", {
        pagination: {
          page: 1,
          perPage: 1000,
        },
        filter: {},
        sort: { field: "country", order: "ASC" },
      });
      this.setState({ countries: response.data });
    } catch (error) {
      console.error("Error loading countries:", error);
    }
  };

  updateState = async id => {
    const data = await this.fetchData(id);
    this.setState({ data });
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

    
  habilitarTextboxBooking = () => {
    console.log('edit')
    console.log(this.state.editBooking )
    this.setState({ editBooking: !this.state.editBooking });
  }

  handleChange = (element, type) => {
    this.setState({
      [type]: element.target.value,
    });
  }
  handleSubmitEditBooking = (event) => {
    event.preventDefault();
    this.metodoUpdate(this.state)
  }
  async metodoUpdate (data) {
    let first = data.r_first_name;
    let last = data.r_last_name;
    const dataProvider = await dataProviderFactory("rest");
    const bodyRequest = {
      id: this.props.bookingId, data: {
        r_first_name: first,
        r_last_name: last
      }
    };
    dataProvider(UPDATE, "clients/updateBooking", bodyRequest)
      .then((response) => { 
        console.log(response)
        this.setState({ r_last_name: null, r_first_name: null , showDialog: false, editBooking: false });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  render() {
    const { showDialog, data } = this.state;
    let gpsPrice = 0;
    let vipInsurancePrice = 0;
    let model1Price = 0;
    let model2Price = 0;
    let rentalDays = 0;
    let occupancyDays = 0;
    let isWeekend = false;
    let lowSeasonPct = 0;
    let rentalTotal1 = 0;
    let rentalTotal2 = 0;
    let locationFee = 0;

    const formatTimePeriod = (time) => {
      const t =
        time === "19:00:00" || time === 19 || time === "19" ? "18:00:00" : time;
      if (t === "10:00:00") return "morning";
      if (t === "15:00:00") return "15:00 afternoon-weekend";
      if (t === "18:00:00") return "evening";
      if (t && String(t).length >= 5) return String(t).slice(0, 5);
      return t || "";
    };

    const getVehicleModelPrices = (modelPrices, days) => {
      const matches = (modelPrices || []).filter(
        price =>
          Number(price.days_interval_1) <= days &&
          Number(price.days_interval_2) >= days
      );
      if (!matches.length) return 0;
      matches.sort((a, b) => {
        const da = a.start_date ? new Date(a.start_date).getTime() : 0;
        const db = b.start_date ? new Date(b.start_date).getTime() : 0;
        return db - da;
      });
      return matches[0].price != null ? Number(matches[0].price) : 0;
    };

    const getDays = () => {
      const { r_time_1, r_date_1, r_date_2, r_time_2 } = data;
      const date1 = moment(r_date_1, "YYYY-MM-DD");
      const date2 = moment(r_date_2, "YYYY-MM-DD");
      let days = moment(date2).diff(date1, "days");

      if (r_time_1 === "10:00:00" && r_time_2 === "18:00:00") {
        days += 1;
      } else if (r_time_1 === "18:00:00" && r_time_2 === "10:00:00") {
        days -= 1;
      }

      return days > 0 ? days : 1;
    };

    if (!isNil(data)) {
      // Preferir fechas/horas del rental (misma fuente que el show) si vienen en props;
      // si no, booking. toDateKey en rentalPromo evita sesgo TZ en ISO UTC.
      const rental = this.props.rental || {};
      const promo = buildRentalPromoSnapshot({
        date_1: rental.date_1 || data.r_date_1,
        time_1: rental.time_1 || data.r_time_1,
        date_2: rental.date_2 || data.r_date_2,
        time_2: rental.time_2 || data.r_time_2,
        from_agency:
          rental.from_agency != null ? rental.from_agency : data.from_agency,
      });
      const motoDays = promo.moto_days;
      const extrasDays = promo.extras_days;
      rentalDays = motoDays;
      occupancyDays = promo.occupancy_days;
      isWeekend = !!promo.is_weekend;
      lowSeasonPct = Number(promo.low_season_pct) || 0;

      model1Price = getVehicleModelPrices(data.v1Prices, motoDays);
      model2Price = getVehicleModelPrices(data.v2Prices, motoDays);

      locationFee =
        data.location_id_1 !== data.location_id_2
          ? prop("price", head(data.locationFees))
          : 0;

      const dailyGps = data.r_gps
        ? Number(
          prop(
            "price",
            head(
              filter(propEq("price_item_type", "gps_device"), data.gpsPrices)
            )
          )
        ) || 0
        : 0;
      gpsPrice = dailyGps;

      const est1 = estimateRentalFromBooking({
        booking: data,
        rental,
        dailyMoto: model1Price,
        dailyGps,
        insurancePrices: data.insurancePrices || [],
        oneWayFee: locationFee || 0,
        rewards: data.rewards || 0,
      });
      const est2 = estimateRentalFromBooking({
        booking: data,
        rental,
        dailyMoto: model2Price,
        dailyGps,
        insurancePrices: data.insurancePrices || [],
        oneWayFee: locationFee || 0,
        rewards: data.rewards || 0,
      });
      vipInsurancePrice = est1.dailyVip;
      rentalTotal1 = est1.totalNet;
      rentalTotal2 = est2.totalNet;
    }

    const calcExperienceYears = (experienceYears) => {
      experienceYears = parseInt(experienceYears, 10);
      let experienceYearsNumber = 0;
      if (!Number.isNaN(experienceYears)) {
        experienceYearsNumber = experienceYears.toString().length === 4 ? (new Date().getFullYear()) - experienceYears : experienceYears
      }
      return experienceYearsNumber;
    }

    return (
      <Fragment>
        <Book
          titleAccess="RENTAL BOOKING FORM"
          onClick={this.handleClick}
          cursor="pointer"
        />
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="RENTAL BOOKING FORM"
        >
          {isNil(data) && <LinearProgress />}
          {!isNil(data) && (
            <React.Fragment>
              <DialogContent ref={this.componentRef}>
                <table border="0" cellpadding="5" spacing="5" width="100%">
                  <tr>
                    <td colspan="2">
                      <StyledH4>RENTAL BOOKING FORM</StyledH4>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <b>Pick-up:</b> {data.location_1.location_name} on{" "}
                      {moment
                        .utc(
                          (this.props.rental && this.props.rental.date_1) ||
                            data.r_date_1
                        )
                        .format("D MMM YYYY")}{" "}
                      (
                      {formatTimePeriod(
                        (this.props.rental && this.props.rental.time_1) ||
                          data.r_time_1
                      )}
                      )
                    </td>

                    <td colspan="1">
                      <b>Drop-off:</b> {data.location_2.location_name} on{" "}
                      {moment
                        .utc(
                          (this.props.rental && this.props.rental.date_2) ||
                            data.r_date_2
                        )
                        .format("D MMM YYYY")}{" "}
                      (
                      {formatTimePeriod(
                        (this.props.rental && this.props.rental.time_2) ||
                          data.r_time_2
                      )}
                      )
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Duration: </b>
                      {occupancyDays} days
                      {" · "}
                      <b>Billable: </b>
                      {rentalDays} days
                      <RentalPromoBadges
                        isWeekend={isWeekend}
                        lowSeasonPct={lowSeasonPct}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <StyledH4>Motorcycle</StyledH4>
                      <b>{` ${data.model_1.model_name} (first choice)`}</b> ,{" "}
                      {` ${data.model_2.model_name} (second choice)`}
                      <br />
                      Daily rate for first choice motorcycle: {model1Price}{" "}
                      Euros/day
                      <br />
                      Daily rate for second choice motorcycle: {
                        model2Price
                      }{" "}
                      Euros/day
                    </td>
                    <td>
                      {data.r_gps && (
                        <React.Fragment>
                          <StyledH4>Gps</StyledH4>
                          {gpsPrice} € / day
                        </React.Fragment>
                      )}
                      {!data.r_gps && <StyledH4>Gps</StyledH4>}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <StyledH4>One-way rental</StyledH4>
                      {data.location_id_1 !== data.location_id_2
                        ? `Yes - ${locationFee} EUR`
                        : "No"}
                    </td>

                    <td>
                      <StyledH4>Insurance</StyledH4>
                      {(() => {
                        const insId = resolveBookingInsuranceId(data);
                        if (!isPaidInsurance(insId)) return "Regular (included)";
                        return `${insuranceLabel(insId)} — ${vipInsurancePrice} Euros/day`;
                      })()}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <StyledH4>IMT Rewards</StyledH4>
                      {!data.reward_used
                        ? "No"
                        : `${data.rewards} Cash Discount`}
                      <StyledH4>Rental Cost</StyledH4>
                      Total rental cost, first choice of motorcycle,{" "}
                      {rentalTotal1} Euros. <br />
                      Total rental cost, second choice of motorcycle,{" "}
                      {rentalTotal2} Euros.
                    </td>
                  </tr>
                  <StyledH4>Rider Info</StyledH4>
                  <tr>
                    <td>
                      <b>Name:</b> {data.r_first_name}{" "}
                      {data.r_last_name}
                    </td>
                    <td>
                      { this.state.editBooking == true && (
                        <div>
                          <input label="First Name" placeholder="First Name" value={this.state.r_first_name} type="text" onChange={(e) =>
                            this.handleChange(e, "r_first_name")
                          } id="r_first_name" name="r_first_name" />
                          <input label="Last Name" placeholder="Last Name" style={{ marginLeft: '8px' }} onChange={(e) =>
                            this.handleChange(e, "r_last_name")
                          } type="text" value={this.state.r_last_name} id="r_last_name" name="r_last_name" />  
                        </div>
                      )}
                    </td>
                    <td>{ this.state.editBooking == false && (
                        <button onClick={this.habilitarTextboxBooking}>Edit</button>
                        )}
                        { this.state.editBooking == true && (
                        <button onClick={(e) => this.handleSubmitEditBooking(e)}>Save</button>
                        )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Nickname:</b> {data.nickname}{" "}
                      {data.nickname}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Address:</b> {data.r_address}, {data.r_zip},{" "}
                      {data.r_city}, {data.r_state_province},{" "}
                      {data.country.country}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Nationality: </b> {getNationality(this.state.countries, data.r_nationality)}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Phone Numbers: </b>{data.r_home_phone} (home) {data.r_home_phone} (work)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Email:</b> {data.r_email}
                    </td>
                    <td>
                      <b>Date of Birth:</b>{" "}
                      {data.r_birthday
                        ? moment(data.r_birthday).format(
                          "DD-MM-YYYY"
                        )
                        : ""}{" "}
                      (
                      {moment().diff(
                        moment(data.r_birthday),
                        "years"
                      )}{" "}
                      years)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Passport:</b> {data.r_passport}
                    </td>
                    <td>
                      <b>Driving Licence:</b> {data.r_license}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Occupation:</b> {data.r_occupation}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Height:</b> {data.r_height}{" "}
                      {data.r_height_unit === "1" ? "ft" : "m "}
                    </td>
                    <td>
                      <b>Weight:</b> {data.r_weight}{" "}
                      {data.r_weight_unit === "1" ? "lbs" : "kg"}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Languages spoken:</b>{" "}
                      {data.r_english ? "English," : ""}{" "}
                      {data.r_spanish ? "Spanish," : ""}{" "}
                      {data.r_french ? "French," : ""}{" "}
                      {data.r_german ? "German," : ""}{" "}
                      {data.r_portuguese ? "Portuguese" : ""}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Emergency Contact Name:</b> {data.r_emergency_name}
                    </td>
                    <td>
                      <b>Emergency Contact: </b>
                      {data.r_emergency_phone}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Relationship: </b>
                      {data.r_emergency_relationship}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Years of riding:</b>
                      {calcExperienceYears(data.r_experience_years)} years
                    </td>
                    <td>
                      <b>Riding last year:</b> {data.r_experience_past_year}{" "}
                      {data.r_experience_past_year_unit === "1"
                        ? "km"
                        : "miles"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Average ride distance:</b>{" "}
                      {data.r_experience_ride_distance}{" "}
                      {data.r_experience_ride_distance_unit === "1"
                        ? "km"
                        : "miles"}
                    </td>
                    <td>
                      <b>Riding last year:</b> {data.r_experience_past_year}{" "}
                      {data.r_experience_past_year_unit === "1"
                        ? "km"
                        : "miles"}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Riding Experience:</b> {data.r_street ? "Street," : ""}{" "}
                      {data.r_sweepers ? "Sweepers," : ""}{" "}
                      {data.r_twisties ? "Twisties," : ""}{" "}
                      {data.r_track ? "Track," : ""}{" "}
                      {data.r_off_road ? "Off-road" : ""}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Motorcycle(s) owned:</b> {data.r_own_models}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Previous Rentals:</b> {data.r_tour_group}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Comments:</b> {data.r_comments}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Allergy/Special Diet:</b> {data.r_allergy_special_diet || "None"}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>How did you find out about us?</b>{" "}
                      {prop("name", data.referral)}
                    </td>
                  </tr>
                </table>
              </DialogContent>
            </React.Fragment>
          )}
          <DialogActions>
            <ReactToPrint
              trigger={() => (
                <Button color="primary" onClick={this.nextClick} label="Print">
                  <Print />
                </Button>
              )}
              content={() => this.componentRef.current}
            />
            <Button label="Close" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RentalBookingFormButton);



// WEBPACK FOOTER //
// ./src/components/rentalBookingForm.js